import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "../../abstractions/abstract.service";
import { Globals } from "../../app.globals";

@Injectable()
export class HealthAndSafetyAdminService extends AbstractService {
    constructor(http: HttpClient, globals: Globals) {
        super(http, globals);
    }

    canAccess(accessTypes: string[]): Promise<boolean> {
        return this.http
            .post<boolean>(this.getApiUrl() + "/can-access", accessTypes)
            .toPromise();
    }

    getAccessLevel(accessTypes: string[]): Promise<string> {
        return this.http
            .post<string>(this.getApiUrl() + "/access-level", accessTypes)
            .toPromise();
    }

    getApiUrl(): string {
        return "api/health-and-safety/admin";
    }
}

export class UnassignedSupervisor {
    employeeId: number;
    fullName: string;
}

export class UnassignedSubcontractorContact {
    subcontractorContactId: number;
    fullName: string;
    subcontractorName: string;
}

export class AssignedSupervisor {
    id: number;
    fullName: string;
    email: string;
    role: string;
    status: string;
}

export class AssignedSubcontractorContact {
    id: number;
    fullName: string;
    subcontractorName: string;
    email: string;
    role: string;
    status: string;
}
